<template>
    <div class="grid-x">
        <div class="cell">
            <div class="grid-x grid-padding-x search-holder">
                <div class="medium-3 cell medium-offset-3 text-right">
                    <p>filter by: </p>
                </div>            
                <div class="medium-3 cell">
                    <select v-model="pubfilter" @change="fetchitems">
                        <option value="">Publication</option>
                        <option v-for="option in publications" v-bind:value="option.pkey">{{ option.pvalue }}</option>
                    </select>
                </div>
                <div class="medium-3 cell">
                    <select v-model="datefilter" placeholder="Date" @change="fetchitems">
                        <option value="">Date</option>
                        <option v-for="option in pubdates" v-bind:value="option.pkey">{{ option.pvalue }}</option>
                    </select>            
                </div>
            </div>  
        </div>
        <div class="large-8 large-offset-2 cell">
            <div class="grid-x grid-padding-y">
                <div v-if="results.length == 0"><p>No articles found</p></div>
                <press-article v-for="(article, index) in results" :article="article" :key="index" />
            </div>
        </div>
    </div>  
</template>
<script setup>
    import { computed, ref, nextTick, onMounted } from 'vue'
    import pressArticle from './press-article.vue'
    import RendiliCore from '@RendiliCore'

    const results = ref([])
    const pubdates = ref(null)
    const publications = ref(null)
    const datefilter = ref('')
    const pubfilter = ref('')

    function getmonths() {
        RendiliCore.Json.Get("/alternative/publication/getdates")
        .then(function (data) {
            pubdates.value = data;
        })
    }

    function getpubs() {
        RendiliCore.Json.Get("/alternative/publication/getpubs")
        .then(function (data) {
            publications.value = data;
            if(window.location.hash) {
                pubfilter.value = window.location.hash.substring(1);
                fetchitems();
            }
        })
    }

    function fetchitems() {
        RendiliCore.Json.PostJsonData({
            url: "/alternative/publication/list", 
            data: {
                date: datefilter.value,
                publication: pubfilter.value
            }           
        })  
        .then(function (data) {
            results.value = data;
        })
    }

    onMounted(() => {
        getmonths();
        getpubs();
        if(!window.location.hash) {
            fetchitems();
        }
    })

    defineOptions({
        name: 'Press List'
    })
</script>